// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"f5a9a9dc","527":"72b4c548","815":"20402af1"}[chunkId] + ".chunk.js";
};